<template>
<div>
    <h1 class="subtitle">Asignación y Devolución de Items</h1>
    <b-tabs v-model="activeTab" :animated="false" @input="changeTab($event)" type="is-boxed" size="is-small" position="is-centered">
        <b-tab-item label="Asignaciones / Devoluciones">
            <div class="nj-panel">
                <div class="nj-panel-content">
                    <div class="nj-grid">
                        <InputSelect label="Asignaciones / Devoluciones" v-model="tipo_busqueda" id="dp-0" :source="tipos_asignaciones" itemKey="tia_id" itemValue="tia_id" itemFilter="tia_nombre"
                            :labelFunction="(item) => item.tia_nombre" @selectItem="seleccionarTipoBusqueda()">
                            <template #default="data">
                                {{ data.item.tia_nombre }}
                            </template>
                        </InputSelect>
                        <InputSelect label="Almacenes" v-model="request.alm_id" id="dp-1" :source="almacenes" itemKey="alm_id" itemValue="alm_id" :filterFunction="filterAlmacenes"
                            :labelFunction="labelAlmacen">
                            <template #default="data">
                                {{ labelAlmacen(data.item) }}
                            </template>
                        </InputSelect>
                        <InputSelect label="Solicitante" v-model="request.emp_solicitante" id="dp-2" :source="solicitantes" itemKey="emp_id" itemValue="emp_id" :filterFunction="filterUsuario"
                            :labelFunction="labelUsuario">
                            <template #default="data">
                                {{ labelUsuario(data.item) }}
                            </template>
                        </InputSelect>
                        <InputSelect label="Autorizador" v-model="request.emp_autorizador" id="dp-3" :source="autorizadores" itemKey="emp_id" itemValue="emp_id" :filterFunction="filterUsuario"
                            :labelFunction="labelUsuario">
                            <template #default="data">
                                {{ labelUsuario(data.item) }}
                            </template>
                        </InputSelect>
                        <div>
                            <div class="nj-label">N° Asignacion</div>
                            <input type="text" class="nj-text" v-model="request.ait_id" ref="ait_id">
                        </div>
                        <InputDate label="Rango fechas" v-model="request.ait_fecha_inicio"></InputDate>
                        <InputDate label="" v-model="request.ait_fecha_fin"></InputDate>
                        <InputSelect label="Estados" v-model="request.estado" id="dp-4" :source="estados" itemKey="est_id" itemValue="est_id" itemFilter="est_nombre" :labelFunction="labelEstado">
                            <template #default="data">
                                {{ labelEstado(data.item) }}
                            </template>
                        </InputSelect>
                    </div>
                    <br>
                    <div class="nj-flex">
                        <Button label="Buscar" icon="find" @click="buscar()"></Button>
                        <Button label="Asignar" icon="save" color="green" @click="openAsignar()" activationCode="registrar_asignacion"></Button>
                        <Button label="Devolver" icon="save" color="blue" @click="openDevolucion()" activationCode="registrar_devolucion"></Button>
                    </div>
                    <br>
                    <b-table v-if="tipo_busqueda == 1" :data="asignaciones" :paginated="true" :per-page="10" current-page.sync="1" :pagination-simple="true" pagination-position="bottom"
                        default-sort-direction="asc" :pagination-rounded="false" sort-icon="arrow-up" sort-icon-size="is-small" aria-next-label="Next page" aria-previous-label="Previous page"
                        aria-page-label="Page" aria-current-label="Current page">
                        <template slot-scope="props">
                            <b-table-column label="ID" header-class="is-info">{{ props.row.ait_id }}</b-table-column>
                            <b-table-column label="Fecha asignación" header-class="is-info">{{ props.row.ait_fecha_registro }}</b-table-column>
                            <b-table-column label="Solicitante" header-class="is-info">{{ props.row.emp_solicitante_nombre }}</b-table-column>
                            <b-table-column label="Autorizador" header-class="is-info">{{ props.row.emp_autorizador_nombre }}</b-table-column>
                            <b-table-column label="Registrado por" header-class="is-info">{{ props.row.usu_registrador_nombre }}</b-table-column>
                            <b-table-column label="Estado" header-class="is-info">
                                <b-field>
                                    <b-tag :class="props.row.est_styles">{{ props.row.est_nombre }}</b-tag>
                                </b-field>
                            </b-table-column>
                            <b-table-column label="Opciones" header-class="is-info">
                                <div class="nj-flex">
                                    <Button title="Ver asignacion" icon="info" @click="openAsignacionView(props.row.ait_id)"></Button>
                                    <Button title="Eliminar asignacion" icon="remove" color="red" @click="eliminarAsignacion(props.row)"
                                        :activation="activarEliminarAsignacion(props.row.ait_estado)"></Button>
                                </div>
                            </b-table-column>
                        </template>
                    </b-table>
                    <b-table v-if="tipo_busqueda == 2" :data="devoluciones" :paginated="true" :per-page="10" current-page.sync="1" :pagination-simple="true" pagination-position="bottom"
                        default-sort-direction="asc" :pagination-rounded="false" sort-icon="arrow-up" sort-icon-size="is-small" aria-next-label="Next page" aria-previous-label="Previous page"
                        aria-page-label="Page" aria-current-label="Current page">
                        <template slot-scope="props">
                            <b-table-column label="ID" header-class="is-info">{{ props.row.ait_id }}</b-table-column>
                            <b-table-column label="Fecha asignación" header-class="is-info">{{ props.row.did_fecha_registro }}</b-table-column>
                            <b-table-column label="Solicitante" header-class="is-info">{{ props.row.emp_solicitante_nombre }}</b-table-column>
                            <b-table-column label="Autorizador" header-class="is-info">{{ props.row.emp_autorizador_nombre }}</b-table-column>
                            <b-table-column label="Registrado por" header-class="is-info">{{ props.row.usu_registrador_nombre }}</b-table-column>
                            <b-table-column label="Estado" header-class="is-info">
                                <b-field>
                                    <b-tag :class="props.row.est_">{{ props.row.est_nombre }}</b-tag>
                                </b-field>
                            </b-table-column>
                            <b-table-column label="Opciones" header-class="is-info">
                                <div class="nj-flex">
                                    <Button title="Ver devolución" icon="info" @click="openDevolucionView(props.row.dei_id)"></Button>
                                    <Button title="Eliminar devolución" icon="remove" color="red" @click="eliminarDevolucion(props.row)"
                                        :activation="activarEliminarDevolucion(props.row.dei_estado)"></Button>
                                </div>
                            </b-table-column>
                        </template>
                    </b-table>
                </div>
            </div>
        </b-tab-item>
        <b-tab-item label="Asignaciones x Items">
            <div class="nj-panel">
                <div class="nj-panel-content">
                    <div class="nj-grid">
                        <InputSelect label="Almacen" v-model="request2.alm_id" id="dp-5" :source="almacenes" itemKey="alm_id" itemValue="alm_id" :filterFunction="filterAlmacenes"
                            :labelFunction="labelAlmacen">
                            <template #default="data">
                                {{ labelAlmacen(data.item) }}
                            </template>
                        </InputSelect>
                        <SearchBox label="Item" id="sb-1" v-model="request2.prv_id" itemKey="prv_id" itemValue="prv_id" :source="productos" :labelFunction="(item) => item.prv_nombre"
                            :searchFunction="buscarProducto">
                            <template #default="data">
                                {{ data.item.prv_nombre }}
                            </template>
                        </SearchBox>
                        <InputSelect label="Solicitante" v-model="request2.emp_solicitante" id="dp-6" :source="solicitantes" itemKey="emp_id" itemValue="emp_id" :filterFunction="filterUsuario"
                            :labelFunction="labelUsuario">
                            <template #default="data">
                                {{ labelUsuario(data.item) }}
                            </template>
                        </InputSelect>
                        <InputSelect label="Autorizador" v-model="request2.emp_autorizador" id="dp-7" :source="autorizadores" itemKey="emp_id" itemValue="emp_id" :filterFunction="filterUsuario"
                            :labelFunction="labelUsuario">
                            <template #default="data">
                                {{ labelUsuario(data.item) }}
                            </template>
                        </InputSelect>
                        <div class="nj-flex">
                            <InputDate label="Rango fechas" v-model="ait_fecha_inicio"></InputDate>
                            <InputDate label="" v-model="ait_fecha_fin"></InputDate>
                        </div>
                    </div>
                    <br>
                    <div class="nj-flex">
                        <Button label="Buscar" icon="find" @click="buscarAsignacionesxItems()"></Button>
                    </div>
                    <br>
                    <b-table :data="asignaciones_x_items" @page-change="changePage($event)" :total="request2.page.total" :per-page="request2.page.size" :current-page="request2.page.number"
                        :paginated="true" :backend-pagination="true" pagination-order="is-centered">
                        <template slot-scope="props">
                            <b-table-column label="Producto" header-class="is-info">{{ props.row.prv_nombre }}</b-table-column>
                            <b-table-column label="Cantidad" header-class="is-info">{{ props.row.aid_cantidad }}</b-table-column>
                            <b-table-column label="Saldo" header-class="is-info">{{ props.row.aid_saldo }}</b-table-column>
                            <b-table-column label="Solicitante" header-class="is-info">{{ props.row.emp_solicitante_nombre }}</b-table-column>
                            <b-table-column label="Autorizador" header-class="is-info">{{ props.row.emp_autorizador_nombre }}</b-table-column>
                            <b-table-column label="Fecha registro" header-class="is-info">{{ props.row.ait_fecha_registro }}</b-table-column>
                            <b-table-column label="Opciones" header-class="is-info" style="width: 80px;">
                                <Button title="Devoluciones" icon="info"
                                    @click="popup({ interfaz: 'devolucionesxItem', activar: true, ait_id: props.row.ait_id, prv_nombre: props.row.prv_nombre })"></Button>
                            </b-table-column>
                        </template>
                    </b-table>
                </div>
            </div>
        </b-tab-item>
    </b-tabs>
    <RegistrarAsignacionItems v-if="activarAsignar" @close="closePopups($event)"></RegistrarAsignacionItems>
    <VerAsignacionItems v-if="activarAsignacionView" @close="closePopups()" :ait_id="ait_id"></VerAsignacionItems>
    <RegistrarDevolucionItems v-if="activarDevolver" @close="closePopups($event)"></RegistrarDevolucionItems>
    <VerDevolucionItems v-if="activarDevolucionView" @close="closePopups()" :dei_id="dei_id"></VerDevolucionItems>
    <DevolucionesxItem v-if="activarDevolucionesxItem" :aid_id="aid_id" :prv_nombre="prv_nombre" @close="popup({ interfaz: 'devolucionesxItem', activar: false })"></DevolucionesxItem>
</div>
</template>

<script>
import { EstadoEnum } from "../../constants"
import { AsignacionItemsService, DevolucionItemsService, EmpleadoService, ProductoAlmacenService, ResponseStatus, UsuarioService } from "../../rest"
import OpcionesService from "../../rest/OpcionesService"
import { Confirm, DateTime, Validator } from "../../util"
import Toast from "../../util/toast"
import { Button, Buttons, InputDate, InputSelect, InputSimpleSelect, InputText, SearchBox } from "../components"
import DevolucionesxItem from "./DevolucionesxItem.vue"
import RegistrarAsignacionItems from "./RegistrarAsignacionItems"
import RegistrarDevolucionItems from "./RegistrarDevolucionItems"
import VerAsignacionItems from "./VerAsignacionItems"
import VerDevolucionItems from "./VerDevolucionItems"

export default {
    name: "AsignacionItems",
    data() {
        return {
            tipos_asignaciones: [],
            tipo_busqueda: 1,
            estados: [],
            request: {
                ait_id: null,
                alm_id: null,
                emp_solicitante: null,
                ait_fecha_inicio: null,
                ait_fecha_fin: null,
                ait_estado: null,
                did_estado: null,
                estado: 1,
                aid_id: null,
            },
            request2: {
                alm_id: null,
                emp_solicitante: null,
                emp_autorizador: null,
                ait_fecha_inicio: null,
                ait_fecha_fin: null,
                ait_estado: null,
                prv_id: null,
                page: {
                    number: 1,
                    size: 10
                }
            },
            emp_nombre: "", // utilizado en la búsqueda rapida del empleado
            activarAsignar: false,
            activarDevolver: false,
            activarAsignacionView: false,
            activarDevolucionView: false,
            activarDevolucionesxItem: false,
            asignaciones: [],
            devoluciones: [],
            almacenes: [],
            productos: [],
            solicitantes: [],
            autorizadores: [],
            asignaciones_x_items: [],
            ait_id: null,
            aid_id: null,
            dei_id: null,
            activeTab: 0,
            ait_fecha_inicio: null,
            ait_fecha_fin: null,
            prv_nombre: null,
        }
    },
    components: {
        RegistrarAsignacionItems,
        VerAsignacionItems,
        RegistrarDevolucionItems,
        VerDevolucionItems,
        Buttons,
        Button,
        InputText,
        InputSelect,
        InputSimpleSelect,
        SearchBox,
        InputDate,
        DevolucionesxItem,
    },
    methods: {
        changeTab(tab) {
            switch (tab) {
                case 0:
                    this.buscar()
                    break
                case 1:
                    this.buscarAsignacionesxItems()
                    break
                case 2:
                    break
            }
        },
        seleccionarTipoBusqueda() {
            this.request.estado = 3
            this.buscar()
        },
        buscar() {
            this.asignaciones = []
            this.devoluciones = []
            if (this.tipo_busqueda) {
                if (this.tipo_busqueda == 1) {
                    this.request.ait_estado = this.request.estado
                    const request = {
                        asignacion_items: this.request
                    }
                    AsignacionItemsService
                        .buscar(request)
                        .then(response => {
                            if (ResponseStatus.isSuccess(response)) {
                                this.asignaciones = response.data
                            }
                            else {
                                Toast.warn(response.message)
                            }
                        })
                        .catch(error => {
                            Toast.error(error)

                        })
                } else {
                    this.request.dei_estado = this.request.estado
                    const request = {
                        devolucion_items: this.request
                    }
                    DevolucionItemsService
                        .buscar(request)
                        .then(response => {
                            if (ResponseStatus.isSuccess(response)) {
                                this.devoluciones = response.data
                            }
                            else {
                                Toast.warn(response.message)
                            }
                        })
                        .catch(error => {
                            Toast.error(error)

                        })
                }
            }
        },
        buscarEmpleado() {
            EmpleadoService
                .buscar({
                    empleado: {
                        pry_id: UsuarioService.getUsuario().pry_id,
                        epr_estado: EstadoEnum.ACTIVO.est_id
                    }
                })
                .then(response => {
                    this.autorizadores = response.data
                    this.solicitantes = response.data
                })
                .catch(error => {
                    Toast.error(error)
                })
        },
        filterUsuario(items, param) {
            if (param != null && param != "") {
                return items.filter(item => item.emp_nombre_completo.toLowerCase().includes(param.toLowerCase()))
            }
            else {
                return items
            }
        },
        labelUsuario(item) {
            return item.emp_nombre_completo
        },
        activarEliminarAsignacion(ait_estado) {
            return EstadoEnum.CREADO.est_id == ait_estado
        },
        activarEliminarDevolucion(dei_estado) {
            return EstadoEnum.CREADO.est_id == dei_estado
        },
        openAsignar() {
            this.activarAsignar = true
        },
        openDevolucion() {
            this.activarDevolver = true
        },
        openAsignacionView(ait_id) {
            this.ait_id = ait_id
            this.activarAsignacionView = true
        },
        openDevolucionView(dei_id) {
            this.dei_id = dei_id
            this.activarDevolucionView = true
        },
        closePopups(condition) {
            this.activarAsignar = false
            this.activarDevolver = false
            this.activarAsignacionView = false
            this.activarDevolucionView = false
            if (condition) {
                this.buscar()
            }
        },
        eliminarAsignacion(item) {
            Confirm.show({
                message: "¿Esta seguro de eliminar la asignación?",
                action: () => {
                    AsignacionItemsService
                        .eliminar({
                            asignacion_items: {
                                ait_id: item.ait_id
                            }
                        })
                        .then(response => {
                            if (ResponseStatus.isSuccess(response)) {
                                Toast.success(response.message)
                                this.buscar()
                            }
                            else {
                                Toast.warn(response.message)
                            }
                        })
                        .catch(error => {
                            Toast.error(error)
                        })
                }
            })
        },
        eliminarDevolucion(item) {
            Confirm.show({
                message: "¿Esta seguro de eliminar la devolución?",
                action: () => {
                    const request = {
                        devolucion_items: {
                            dei_id: item.dei_id
                        }
                    }
                    DevolucionItemsService.eliminar(request).then(
                        response => {
                            Toast.success(response.message)
                            this.buscar()
                        },
                        error => {
                            Toast.error(error)
                            console.error(`error: `, error)
                        }
                    )
                }
            })
        },
        labelAlmacen(item) {
            return `${item.pry_nombre} | ${item.alm_nombre} ${item.alm_tipo == 0 ? "*" : ""}`
        },
        filterAlmacenes(items, param) {
            if (param != null) {
                return items.filter(item => `${item.pry_nombre} | ${item.alm_nombre} ${item.alm_tipo == 0 ? "*" : ""}`.toLowerCase().includes(param.toLowerCase()))
            }
            else {
                return items
            }
        },
        labelEstado(item) {
            return item.est_nombre
        },
        buscarAsignacionesxItems() {
            if (this.ait_fecha_inicio) {
                this.request2.ait_fecha_inicio = DateTime.dateToString(this.ait_fecha_inicio)
            }
            if (this.ait_fecha_fin) {
                this.request2.ait_fecha_fin = DateTime.dateToString(this.ait_fecha_fin)
            }
            const request = {
                asignacion_items_detalle: this.request2
            }
            AsignacionItemsService.buscarAsignacionesxItems(request).then(response => {
                if (ResponseStatus.isSuccess(response)) {
                    this.request2.page = response.data
                    this.asignaciones_x_items = this.request2.page.list
                }
                else {
                    Toast.warn(response.message)
                }
            }).catch(error => {
                Toast.error(error)

            })
        },
        changePage(number) {
            this.request2.page.number = number
            this.buscarAsignacionesxItems()
        },
        buscarProducto(prv_nombre) {
            if (Validator.start(this.request2.alm_id)) {
                ProductoAlmacenService
                    .buscarRapido({
                        producto_almacen: {
                            prv_nombre,
                            alm_id: this.request2.alm_id
                        }
                    })
                    .then(response => {
                        if (ResponseStatus.isSuccess(response)) {
                            this.productos = response.data
                        }
                        else {
                            Toast.warn(response.message)
                        }
                    })
                    .catch(error => {
                        Toast.error(error)
                    })
            }
            else {
                Toast.warn("Debe seleccionar un almacén")
            }
        },
        popup({
            interfaz,
            activar,
            aid_id = null,
            prv_nombre = null
        }) {
            switch (interfaz) {
                case "devolucionesxItem":
                    this.activarDevolucionesxItem = activar
                    break
                default:
                    break
            }
            if (aid_id != null) {
                this.aid_id = aid_id
            }
            if (prv_nombre != null) {
                this.prv_nombre = prv_nombre
            }
        },
    },
    mounted() {
        OpcionesService
            .getOpciones({
                estado: {
                    modulo: "asignacionesItems"
                },
                almacen: {
                    alm_estado: EstadoEnum.ACTIVO.est_id,
                    pry_id: !UsuarioService.isCoorporative()
                        ? UsuarioService.getUsuario().pry_id
                        : null
                },
                tipo_asignacion: {
                    tid_id: null
                }
            })
            .then(response => {
                if (ResponseStatus.isSuccess(response)) {
                    this.tipos_asignaciones = response.data.tipos_asignacion
                    this.estados = response.data.estados
                    this.almacenes = response.data.almacenes
                    this.ait_fecha_inicio = DateTime.getDate()
                    this.ait_fecha_fin = DateTime.getDate({ days: 1 })
                    this.buscarEmpleado()
                    this.buscar()
                }
                else {
                    Toast.warn(response.message)
                }
            })
            .catch(error => {
                Toast.error(error)
            })
    },
}
</script>

<style scoped></style>